import type {ReactElement} from 'react';
import React from 'react';
import BottomBar from '@Components/contextual-menu/components/bottom-bar';
import {openPosterEditorDrawBrushModal} from '@Modals/poster-editor-draw-brush-modal';
import {ERASER_BRUSH, PENCIL_BRUSH} from '@PosterWhiteboard/models/draw.class';
import {openPosterEditorDrawBrushSizeModal} from '@Modals/poster-editor-draw-brush-size-modal';
import {openPosterEditorDrawBrushColorModal} from '@Modals/poster-editor-draw-brush-color-modal';
import {useEditorPrefetchDrawMobileModules} from '@Hooks/poster-editor/useEditorPrefetchDrawModeMobileModules';
import {DrawBottomBar} from '@Components/poster-editor/components/poster-editor-bottom-bar/poster-editor-bottom-bar.types';
import {useAppSelector} from '@/hooks';

export function DrawModeBottomBar(): ReactElement<any> | null {
  const isDrawModeActive = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.isDrawModeOn;
  });
  const drawBrush = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.drawBrush.brush;
  });
  const isImageGeneratingFromDrawing = useAppSelector((state) => {
    return state.posterEditor.posterObject?.drawing.isImageBeingGenerated;
  });
  useEditorPrefetchDrawMobileModules();

  if (!isDrawModeActive && !isImageGeneratingFromDrawing) {
    return null;
  }

  const onClickHandler = (id: DrawBottomBar): void => {
    switch (id) {
      case DrawBottomBar.BRUSH:
        openPosterEditorDrawBrushModal();
        break;
      case DrawBottomBar.BRUSH_SIZE:
        openPosterEditorDrawBrushSizeModal();
        break;
      case DrawBottomBar.COLOR:
        openPosterEditorDrawBrushColorModal();
        break;
      case DrawBottomBar.ERASER:
        if (drawBrush === ERASER_BRUSH) {
          void window.posterEditor?.whiteboard?.drawing.updateBrushType(PENCIL_BRUSH);
        } else {
          void window.posterEditor?.whiteboard?.drawing.updateBrushType(ERASER_BRUSH);
        }
        break;
      default:
        break;
    }
  };

  return (
    <BottomBar
      id="poster-editor-draw-bottom-bar"
      items={[
        {
          id: DrawBottomBar.BRUSH,
          icon: 'icon-brush-type',
          text: window.i18next.t('pmwjs_brush'),
          isDisabled: isImageGeneratingFromDrawing,
        },
        {
          id: DrawBottomBar.ERASER,
          icon: 'icon-eraser',
          text: window.i18next.t('pmwjs_eraser'),
          isDisabled: isImageGeneratingFromDrawing,
          isSelected: drawBrush === ERASER_BRUSH,
        },
        {
          id: DrawBottomBar.COLOR,
          icon: 'icon-colorpicker',
          isDisabled: isImageGeneratingFromDrawing,
          text: window.i18next.t('pmwjs_color'),
          isHidden: drawBrush === ERASER_BRUSH,
        },
        {
          id: DrawBottomBar.BRUSH_SIZE,
          icon: 'icon-brush-size',
          isDisabled: isImageGeneratingFromDrawing,
          text: drawBrush === ERASER_BRUSH ? window.i18next.t('pmwjs_size') : window.i18next.t('pmwjs_brush_size'),
        },
      ]}
      onClick={onClickHandler}
    />
  );
}
